<template>
   <div v-if="plan" class="plan-desc" :style="{background}">
      <div>
         <span class="label">Plan Name</span>
         <span class="value">{{ plan.name }}</span>
      </div>
      <div>
         <span class="label">Plan Period</span>
         <span class="value">{{ plan.period_yr }} Yrs</span>
      </div>
      <div>
         <span class="label">District</span>
         <span class="value">{{ plan.municipality.district }}</span>
      </div>
      <div>
         <span class="label">Municipality</span>
         <span class="value">{{ plan.municipality.name }}</span>
      </div>
   </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex'
import { selectMunicipalityFromTop } from '../../../../../js/mapNavigator';

export default {
   name: 'plan-description',
   methods: mapActions('plan', ['fetchPlan']),
   props: {
      background: {
         type: String,
         default: 'white',
      },
   },
   computed: {
      ...mapGetters('plan', ['getPlan']),
   },
   asyncComputed: {
      async plan()
      {
         if ( this.getPlan==null || (this.getPlan && parseInt(this.getPlan.id) !== parseInt(this.$route.params.id)) )
         {
            await this.fetchPlan(this.$route.params.id)
            selectMunicipalityFromTop(this.getPlan.municipality.sddmm);
         }
         return this.getPlan;
      }
   },
}
</script>

<style lang="scss" scoped>

.plan-desc {
   width: 100%;
   padding: 1em;
   display: flex;
   flex-wrap: wrap;

   > * {
      flex: 1 0 50%;
      min-width: 200px;
      padding: 0.5em 0;
   }
   .label,.value {
      display: block;
      font-size: 0.9em;
   }
   .label {
      text-transform: uppercase;
   }
   .value {
      font-weight: 600;
   }
}
</style>